import React, { useEffect, useContext } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Trans } from 'react-i18next';
import { Container } from 'reactstrap';
import { OrderContext } from '../context/OrderContext';
import { CampaignContext } from '../context/CampaignWrapper';
import { isDefined } from '../utils/helpers';
import { TRANSLATED_ROUTES } from '../config/i18n';

const FinalOrderRedirect = () => {
  const { campaign } = useContext(CampaignContext);
  const { setArticleQuantity, resetOrder } = useContext(OrderContext);
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const { slug } = useParams();

  const isFinalOrder = campaign?.onlyFinalOrderAllowed;

  const allowedPaths = ['checkout'].concat(...Object.values(TRANSLATED_ROUTES)).map((s) => `/${s}/`);
  const isAllowedPath = allowedPaths.some((path) => pathname.includes(path));

  // Redirect to checkout
  useEffect(() => {
    if (isFinalOrder && !isAllowedPath) {
      navigate(`/${slug}/checkout${search}`);
    }
  }, [isAllowedPath, isFinalOrder, navigate, search, slug]);

  // Fill in all itemsLeft
  useEffect(() => {
    if (isFinalOrder) {
      campaign?.articles.forEach((a) => {
        if (a.__typename === 'Article' && isDefined(a.itemsLeft) && a.itemsLeft >= 0) setArticleQuantity(a._id, a.itemsLeft);
        else setArticleQuantity(a._id, 0);
      });
    }
  }, [campaign?.articles, isFinalOrder, resetOrder, setArticleQuantity]);

  if (!isFinalOrder || (isAllowedPath && !pathname.includes('/checkout'))) return null;

  // Show banner
  return (
    <div className="header py-3" style={{ background: 'var(--bs-orange)', color: 'white' }}>
      <Container className="py-3 py-md-0 lh-lg">
        <Trans i18nKey="COMPONENTS.FINAL_ORDER">
          The supplier of this sale requires that the items be sold in certain quantities.
          <br />
          As this campaign is coming to an end, you can only order the quantities necessary to meet these multiples.
          <br />
          Please place this order as soon as possible so that delivery can take place on time.
        </Trans>
      </Container>
    </div>
  );
};

export default FinalOrderRedirect;
